export const keys = {
  form: {
    seoDescription: 'form.seoDescription',
    fullname: 'form.fullname',
    email: 'form.email',
    interestAreas: 'form.interestAreas',
    message: 'form.message',
    resume: 'form.resume',
    acceptPrivacyPolicy: 'form.acceptPrivacyPolicy',
    button: 'form.button',
  },
  snackbar: {
    success: 'snackbar.success',
    error: 'snackbar.error',
  },
};
